module.exports = __webpack_public_path__ + "img/0.28521669.jpg";